module.exports = __webpack_public_path__ + "beaaed119dded8937df6c74bf9545909.svg";